const headings = {
  config: 'Konfigurator',
  shoppingCart: 'Warenkorb',
  setup: 'Konfiguration',
  draft: 'Skizze / Draufsicht',
  newConf: {
    text: 'Neu',
    icon: 'arrow-clockwise'
  },
  newConfModal: {
    title: 'Konfiguration neu starten',
    textInput: 'Mit dem Start einer neuen Konfiguration gehen Ihre bisherigen Eingaben verloren.',
    textCart: 'Ihr Warenkorb bleibt erhalten.'
  }
}

export default {
  headings
}
